// Central site config used across SEO, schema, sitemap and pages.
export const SITE = {
  name: "The VIN Verifier CA",
  legalName: "The VIN Verifier CA",
  url: "https://thevinverifierca.com",
  phone: "(657) 768-6189",
  phoneHref: "tel:+16577686189",
  sms: "sms:+16577686189",
  smsRaw: "+16577686189",
  email: "contact@thevinverifierca.com",
  hours: "Mon–Sat · 7:00 AM – 8:00 PM",
  license: "California Licensed · Verified & Bonded",
  ogImage: "https://thevinverifierca.com/vin-verification-hero.jpg",
  areaServed: ["Orange County", "Los Angeles County"],
};
